import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ColumnNamesUtilityService {
    public constructor() { }

    public getContractColumnName() : Array<object> {
        const column = [
            { field: 'contractId', header: 'Contract No' },
            { field: 'partnerId', header: 'Partner ID' },
            { field: 'pac', header: 'PAC' },
            { field: 'productCode', header: 'Product Code' },
            { field: 'activationCount', header: 'First Activation' },
            { field: 'transactionDateTime', header: 'Transaction Date (UTC)' },
            { field: 'activationStartDatetime', header: 'Activation Start Date (UTC)' },
            { field: 'activationEnddate', header: 'Activation End Date (UTC)' }
        ];
        return column;
    }

    public getTestActivationColumnName() : Array<object> {
        const testActivationColumn = [
            { field: 'partnerId', header: 'Partner ID' },
            { field: 'pac', header: 'PAC' },
            { field: 'productCode', header: 'Product Code' },
            { field: 'testStartDate', header: 'Start Date (UTC)' },
            { field: 'testEndDate', header: 'End Date (UTC)' },
            { field: 'status', header: 'Status' }
        ];
        return testActivationColumn;
    }

    public customerActivationColumnName() : Array<object> {
        const customerColumn = [
            { field: 'partnerId', header: 'Partner ID' },
            { field: 'pac', header: 'PAC' },
            { field: 'productCode', header: 'Product Code' },
            { field: 'serviceLevelName', header: 'Contract Service' },
            { field: 'activationStartDatetime', header: 'Start Date (UTC)' },
            { field: 'activationEnddate', header: 'End Date (UTC)' },
            { field: 'status', header: 'Status' }
        ];
        return customerColumn;
    }
}
